import LoadableToast from './LoadableToast';

export default LoadableToast;
